export const CalculatePassTime = (prev: Date) => {
  const seconds = Math.ceil(
    (new Date().getTime() -
      prev.getTime() +
      prev.getTimezoneOffset() * 60 * 1000) /
      1000
  );
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days} days`;
  if (hours > 0) return `${hours} hours`;
  if (minutes > 0) return `${minutes} mins`;
  return `${seconds <= 0 ? 1 : seconds} secs`;
};

export const convertTimestampToLocal = (date: Date) => {
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  return date;
};
